<template>
  <div>
    <material-card :title="''" :color="$vuetify.theme.themes.light.success" icon="add">
      <v-card-text style="margin-top:20px">
        <pbas-data-table
          v-if="provider !== null && provider !== undefined"
          ref="table"
          :dataProvider="provider"
          identifier="hoursAddMany"
          @error="error = $event"
          :showSelect="false"
          :floatActions="floatActions"
          :rowActions="rowActions"
          @itemsChanged="setData($event)"
        >
          <template
            v-for="(header, index) in provider.headers"
            v-slot:[itemSlotFunc(header)]="{ item }"
          >
            <div
              v-bind:key="header.type.key"
              v-if="header.type.key === 'MemberCertificate'"
              style="justify-content:center"
            >
              <v-btn
                v-if="index === 0"
                small
                text
                @click.prevent="rowActions[0].handler(item)"
              >
                <v-icon>
                  {{ rowActions[0].icon }}
                </v-icon>
                {{ $t(rowActions[0].title) }}
              </v-btn>
              <no-autocomplete-textfield
                clearable
                style="min-width:200px;padding:0"
                :value="item.MemberCertificate"
                @input="updateRow($event, item, 'MemberCertificate')"
                :rules="
                  requiredColumns.indexOf('MemberCertificate') > -1
                    ? [$rules.required]
                    : []
                "
                :class="
                  requiredColumns.indexOf('MemberCertificate') > -1
                    ? 'required'
                    : ''
                "
                label=" "
              />
            </div>
            <div
              v-bind:key="header.type.key"
              v-if="header.type.key === 'SIN'"
              style="justify-content:center"
            >
              <v-btn
                v-if="index === 0"
                small
                text
                @click.prevent="rowActions[0].handler(item)"
              >
                <v-icon>
                  {{ rowActions[0].icon }}
                </v-icon>
                {{ $t(rowActions[0].title) }}
              </v-btn>
              <no-autocomplete-textfield
                clearable
                style="min-width:200px;padding:0"
                :value="item.SIN"
                @input="updateRow($event, item, 'SIN')"
                :rules="
                  requiredColumns.indexOf('SIN') > -1 ? [$rules.required] : []
                "
                :class="requiredColumns.indexOf('SIN') > -1 ? 'required' : ''"
                label=" "
              />
            </div>
            <div
              v-bind:key="header.type.key"
              v-if="header.type.key === 'FirstName'"
              style="justify-content:center"
            >
              <v-btn
                v-if="index === 0"
                small
                text
                @click.prevent="rowActions[0].handler(item)"
              >
                <v-icon>
                  {{ rowActions[0].icon }}
                </v-icon>
                {{ $t(rowActions[0].title) }}
              </v-btn>
              <no-autocomplete-textfield
                clearable
                style="min-width:200px;padding:0"
                :value="item.FirstName"
                @input="updateRow($event, item, 'FirstName')"
                :rules="
                  requiredColumns.indexOf('FirstName') > -1
                    ? [$rules.required]
                    : []
                "
                :class="
                  requiredColumns.indexOf('FirstName') > -1 ? 'required' : ''
                "
                label=" "
              />
            </div>
            <div
              v-bind:key="header.type.key"
              v-if="header.type.key === 'LastName'"
              style="justify-content:center"
            >
              <v-btn
                v-if="index === 0"
                small
                text
                @click.prevent="rowActions[0].handler(item)"
              >
                <v-icon>
                  {{ rowActions[0].icon }}
                </v-icon>
                {{ $t(rowActions[0].title) }}
              </v-btn>
              <no-autocomplete-textfield
                clearable
                style="min-width:200px;padding:0"
                :value="item.LastName"
                @input="updateRow($event, item, 'LastName')"
                :rules="
                  requiredColumns.indexOf('LastName') > -1
                    ? [$rules.required]
                    : []
                "
                :class="
                  requiredColumns.indexOf('LastName') > -1 ? 'required' : ''
                "
                label=" "
              />
            </div>
            <div
              v-bind:key="header.type.key"
              v-if="header.type.key === 'Gender'"
              style="justify-content:center"
            >
              <v-btn
                v-if="index === 0"
                small
                text
                @click.prevent="rowActions[0].handler(item)"
              >
                <v-icon>
                  {{ rowActions[0].icon }}
                </v-icon>
                {{ $t(rowActions[0].title) }}
              </v-btn>
              <trans-select
                clearable
                style="min-width:200px;padding:0"
                :item="item"
                @change="updateRow($event, item, 'Gender')"
                propertyName="Gender"
                :items="options.Models.Gender"
                :rules="
                  requiredColumns.indexOf('Gender') > -1
                    ? [$rules.required]
                    : []
                "
                :class="
                  requiredColumns.indexOf('Gender') > -1 ? 'required' : ''
                "
                label=" "
              ></trans-select>
            </div>
            <div
              v-bind:key="header.type.key"
              v-if="header.type.key === 'DateOfBirth'"
              style="justify-content:center"
            >
              <v-btn
                v-if="index === 0"
                small
                text
                @click.prevent="rowActions[0].handler(item)"
              >
                <v-icon>
                  {{ rowActions[0].icon }}
                </v-icon>
                {{ $t(rowActions[0].title) }}
              </v-btn>
              <pbas-date-picker
                clearable
                v-bind:key="header.type.key"
                style="min-width:200px;margin:0 auto 15px"
                :value="item.DateOfBirth"
                @update-date="updateRow($event, item, 'DateOfBirth')"
                :rules="
                  requiredColumns.indexOf('DateOfBirth') > -1
                    ? [$rules.required]
                    : []
                "
                :class="
                  requiredColumns.indexOf('DateOfBirth') > -1 ? 'required' : ''
                "
                label=" "
              />
            </div>
            <div
              v-bind:key="header.type.key"
              v-if="header.type.key === 'Employer'"
              style="justify-content:center"
            >
              <v-btn
                v-if="index === 0"
                small
                text
                @click.prevent="rowActions[0].handler(item)"
              >
                <v-icon>
                  {{ rowActions[0].icon }}
                </v-icon>
                {{ $t(rowActions[0].title) }}
              </v-btn>
              <trans-select2
                clearable
                style="min-width:200px;padding:0"
                :value="item"
                @change="updateEmployer($event, item)"
                propertyName="Employer"
                :items="employers"
                field="Name"
                itemValue="Id"
                :rules="
                  requiredColumns.indexOf('Employer') > -1
                    ? [$rules.required]
                    : []
                "
                :class="
                  requiredColumns.indexOf('Employer') > -1 ? 'required' : ''
                "
                label=" "
              ></trans-select2>
              <!-- <no-autocomplete-textfield
                style="min-width:200px;padding:0"
                v-bind:key="header.type.key"
                :value="item.Employer"
                @input="updateRow($event, item, 'Employer')"
                :rules="
                  requiredColumns.indexOf('Employer') > -1
                    ? [$rules.required]
                    : []
                "
                :class="
                  requiredColumns.indexOf('Employer') > -1 ? 'required' : []
                "
              /> -->
            </div>
            <div
              v-bind:key="header.type.key"
              v-if="header.type.key === 'EmployeeNumber'"
              style="justify-content:center"
            >
              <v-btn
                v-if="index === 0"
                small
                text
                @click.prevent="rowActions[0].handler(item)"
              >
                <v-icon>
                  {{ rowActions[0].icon }}
                </v-icon>
                {{ $t(rowActions[0].title) }}
              </v-btn>
              <no-autocomplete-textfield
                clearable
                style="min-width:200px;padding:0"
                v-bind:key="header.type.key"
                :value="item.EmployeeNumber"
                @input="updateRow($event, item, 'EmployeeNumber')"
                :rules="
                  requiredColumns.indexOf('EmployeeNumber') > -1
                    ? [$rules.required]
                    : []
                "
                :class="
                  requiredColumns.indexOf('EmployeeNumber') > -1
                    ? 'required'
                    : ''
                "
                label=" "
              />
            </div>
            <div
              v-bind:key="header.type.key"
              v-if="header.type.key === 'Store' && planOptions.HasStores"
              style="justify-content:center"
            >
              <v-btn
                v-if="index === 0"
                small
                text
                @click.prevent="rowActions[0].handler(item)"
              >
                <v-icon>
                  {{ rowActions[0].icon }}
                </v-icon>
                {{ $t(rowActions[0].title) }}
              </v-btn>
              <trans-select2
                clearable
                style="min-width:200px;padding:0"
                :value="item"
                propertyName="Store"
                :items="item.Employer ? item.Employer.Stores : []"
                field="Name"
                itemValue="Id"
                @change="updateStore($event, item)"
                :rules="
                  (item.Employer &&
                    item.Employer.Stores &&
                    item.Employer.Stores.length > 0) ||
                  requiredColumns.indexOf('Store') > -1
                    ? [$rules.required]
                    : []
                "
                :class="
                  (item.Employer &&
                    item.Employer.Stores &&
                    item.Employer.Stores.length > 0) ||
                  requiredColumns.indexOf('Store') > -1
                    ? 'required'
                    : ''
                "
                label=" "
              ></trans-select2>
              <!-- <no-autocomplete-textfield
                style="min-width:200px;padding:0"
                v-bind:key="header.type.key"
                :value="item.Store"
                @input="updateRow($event, item, 'Store')"
                :rules="
                  requiredColumns.indexOf('Store') > -1 ? [$rules.required] : []
                "
                :class="requiredColumns.indexOf('Store') > -1 ? 'required' : []"
              /> -->
            </div>
            <div
              v-bind:key="header.type.key"
              v-if="header.type.key === 'Frequency'"
              style="justify-content:center"
            >
              <v-btn
                v-if="index === 0"
                small
                text
                @click.prevent="rowActions[0].handler(item)"
              >
                <v-icon>
                  {{ rowActions[0].icon }}
                </v-icon>
                {{ $t(rowActions[0].title) }}
              </v-btn>
              <trans-select
                clearable
                style="min-width:200px;padding:0"
                :item="item"
                @change="updateRow($event, item, 'Frequency')"
                propertyName="Frequency"
                :items="options.Models.EmploymentFrequency"
                :rules="
                  requiredColumns.indexOf('Frequency') > -1
                    ? [$rules.required]
                    : []
                "
                :class="
                  requiredColumns.indexOf('Frequency') > -1 ? 'required' : ''
                "
                label=" "
              ></trans-select>
              <!-- <no-autocomplete-textfield
                style="min-width:200px;padding:0"
                v-bind:key="header.type.key"
                :value="item.Frequency"
                @input="updateRow($event, item, 'Frequency')"
                :rules="
                  requiredColumns.indexOf('Frequency') > -1
                    ? [$rules.required]
                    : []
                "
                :class="
                  requiredColumns.indexOf('Frequency') > -1 ? 'required' : []
                "
              /> -->
            </div>
            <div
              v-bind:key="header.type.key"
              v-if="header.type.key === 'EmploymentType'"
              style="justify-content:center"
            >
              <v-btn
                v-if="index === 0"
                small
                text
                @click.prevent="rowActions[0].handler(item)"
              >
                <v-icon>
                  {{ rowActions[0].icon }}
                </v-icon>
                {{ $t(rowActions[0].title) }}
              </v-btn>
              <trans-select
                clearable
                style="min-width:200px;padding:0"
                :item="item"
                @change="updateRow($event, item, 'EmploymentType')"
                propertyName="EmploymentType"
                :items="options.Models.EmploymentType"
                :rules="
                  requiredColumns.indexOf('EmploymentType') > -1
                    ? [$rules.required]
                    : []
                "
                :class="
                  requiredColumns.indexOf('EmploymentType') > -1
                    ? 'required'
                    : ''
                "
                label=" "
              ></trans-select>
              <!-- <no-autocomplete-textfield
                style="min-width:200px;padding:0"
                v-bind:key="header.type.key"
                :value="item.EmploymentType"
                @input="updateRow($event, item, 'EmploymentType')"
                :rules="
                  requiredColumns.indexOf('EmploymentType') > -1
                    ? [$rules.required]
                    : []
                "
                :class="
                  requiredColumns.indexOf('EmploymentType') > -1 ? 'required' : []
                "
              /> -->
            </div>
            <div
              v-bind:key="header.type.key"
              v-if="header.type.key === 'HireDate'"
              style="justify-content:center"
            >
              <v-btn
                v-if="index === 0"
                small
                text
                @click.prevent="rowActions[0].handler(item)"
              >
                <v-icon>
                  {{ rowActions[0].icon }}
                </v-icon>
                {{ $t(rowActions[0].title) }}
              </v-btn>
              <pbas-date-picker
                clearable
                v-bind:key="header.type.key"
                style="min-width:200px;margin:0 auto 15px"
                :value="item.HireDate"
                @update-date="updateRow($event, item, 'HireDate')"
                :rules="
                  requiredColumns.indexOf('HireDate') > -1
                    ? [$rules.required]
                    : []
                "
                :class="
                  requiredColumns.indexOf('HireDate') > -1 ? 'required' : ''
                "
                label=" "
              />
            </div>
            <div
              v-bind:key="header.type.key"
              v-if="header.type.key === 'Earnings'"
              style="justify-content:center"
            >
              <v-btn
                v-if="index === 0"
                small
                text
                @click.prevent="rowActions[0].handler(item)"
              >
                <v-icon>
                  {{ rowActions[0].icon }}
                </v-icon>
                {{ $t(rowActions[0].title) }}
              </v-btn>
              <no-autocomplete-textfield
                clearable
                style="min-width:200px;padding:0"
                :fixedId="'earnings-textbox' + item.Identifier"
                v-bind:key="header.type.key"
                :value="item.Earnings"
                @input="updateRow($event, item, 'Earnings')"
                @keydown="currencyKeydown"
                @keyup="currencyKeyUp($event, item, 'Earnings')"
                :rules="
                  requiredColumns.indexOf('Earnings') > -1
                    ? [$rules.required]
                    : []
                "
                :class="
                  requiredColumns.indexOf('Earnings') > -1 ? 'required' : ''
                "
                label=" "
              />
            </div>
            <div
              v-bind:key="header.type.key"
              v-if="header.type.key === 'TermName'"
              style="justify-content:center"
            >
              <v-btn
                v-if="index === 0"
                small
                text
                @click.prevent="rowActions[0].handler(item)"
              >
                <v-icon>
                  {{ rowActions[0].icon }}
                </v-icon>
                {{ $t(rowActions[0].title) }}
              </v-btn>
              <auto-select
                clearable
                style="min-width:200px;padding:0"
                :value="item.TermName"
                @change="updateRow($event, item, 'TermName')"
                :items="terms"
                class="required"
                label=" "
                item-value="Id"
                return-object
                :slots="true"
                :filter="filterFunc2"
              >
                <template v-slot:selection="data">
                  {{ data.item.Name + " " + data.item.Year }}
                </template>
                <template v-slot:item="data">
                  <v-list-item-content
                    v-text="data.item.Name + ' ' + data.item.Year"
                  ></v-list-item-content>
                </template>
              </auto-select>
            </div>
            <div
              v-bind:key="header.type.key"
              v-if="header.type.key === 'TerminationDate'"
              style="justify-content:center"
            >
              <v-btn
                v-if="index === 0"
                small
                text
                @click.prevent="rowActions[0].handler(item)"
              >
                <v-icon>
                  {{ rowActions[0].icon }}
                </v-icon>
                {{ $t(rowActions[0].title) }}
              </v-btn>
              <pbas-date-picker
                clearable
                v-bind:key="header.type.key"
                style="min-width:200px;margin:0 auto 15px"
                :value="item.TerminationDate"
                @update-date="updateRow($event, item, 'TerminationDate')"
                :rules="
                  requiredColumns.indexOf('TerminationDate') > -1
                    ? [$rules.required]
                    : []
                "
                :class="
                  requiredColumns.indexOf('TerminationDate') > -1
                    ? 'required'
                    : ''
                "
                label=" "
              />
            </div>
            <div
              v-bind:key="header.type.key"
              v-if="header.type.key === 'TerminationReason'"
              style="justify-content:center"
            >
              <v-btn
                v-if="index === 0"
                small
                text
                @click.prevent="rowActions[0].handler(item)"
              >
                <v-icon>
                  {{ rowActions[0].icon }}
                </v-icon>
                {{ $t(rowActions[0].title) }}
              </v-btn>
              <!-- <auto-select
                clearable
                style="min-width:200px;padding:0"
                :value="item.TerminationReason"
                @change="updateRow($event, item, 'TerminationReason')"
                :items="options.Enums.TerminationStatus"
                :rules="hasValue(item.TerminationDate) ? [$rules.required] : []"
                :class="hasValue(item.TerminationDate) ? 'required' : ''"
                :slots="true"
                :filter="filterFunc"
                label=" "
              >
                <template v-slot:selection="data">
                  {{ $t("enums." + data.item) }}
                </template>
                <template v-slot:item="data">
                  <v-list-item-content
                    v-text="$t('enums.' + data.item)"
                  ></v-list-item-content>
                </template>
              </auto-select> -->
              <trans-enum
                clearable
                style="min-width:200px;padding:0"
                :value="item.TerminationReason"
                @change="updateRow($event, item, 'TerminationReason')"
                :items="options.Enums.TerminationStatus"
                :rules="hasValue(item.TerminationDate) ? [$rules.required] : []"
                :class="hasValue(item.TerminationDate) ? 'required' : ''"
                label=" "
              ></trans-enum>
            </div>
            <div
              v-bind:key="header.type.key"
              v-if="header.type.key === 'Amount'"
              style="justify-content:center"
            >
              <v-btn
                v-if="index === 0"
                small
                text
                @click.prevent="rowActions[0].handler(item)"
              >
                <v-icon>
                  {{ rowActions[0].icon }}
                </v-icon>
                {{ $t(rowActions[0].title) }}
              </v-btn>
              <no-autocomplete-textfield
                clearable
                style="min-width:200px;padding:0"
                :fixedId="'hours-amount-textbox' + item.Identifier"
                v-bind:key="header.type.key"
                :value="item.Amount"
                @input="updateRow($event, item, 'Amount')"
                @keydown="currencyKeydownNegative"
                @keyup="currencyKeyUpNegative($event, item, 'Amount')"
                :rules="
                  requiredColumns.indexOf('Amount') > -1
                    ? [$rules.required]
                    : []
                "
                :class="
                  requiredColumns.indexOf('Amount') > -1 ? 'required' : ''
                "
                label=" "
              />
              <!-- <currency-textfield
                prefix=""
                cssstyle="min-width:200px;padding:0;margin-top:-13px"
                :fixedId="'hours-amount-textbox'+item.Identifier"
                v-bind:key="header.type.key"
                :value="item.Amount"
                @input="updateRow($event, item, 'Amount')"
                :rules="
                  requiredColumns.indexOf('Amount') > -1 ? [$rules.required] : []
                "
                :class="requiredColumns.indexOf('Amount') > -1 ? 'required' : []"
              /> -->
            </div>
            <div
              v-bind:key="header.type.key"
              v-if="header.type.key === 'ContributionAmount'"
              style="justify-content:center"
            >
              <v-btn
                v-if="index === 0"
                small
                text
                @click.prevent="rowActions[0].handler(item)"
              >
                <v-icon>
                  {{ rowActions[0].icon }}
                </v-icon>
                {{ $t(rowActions[0].title) }}
              </v-btn>
              <no-autocomplete-textfield
                clearable
                style="min-width:200px;padding:0"
                :fixedId="'hours-contribution-amount-textbox' + item.Id"
                :value="item.ContributionAmount"
                @input="updateRow($event, item, 'ContributionAmount')"
                @keydown="currencyKeydown"
                @keyup="currencyKeyUp($event, item, 'ContributionAmount')"
                :rules="
                  requiredColumns.indexOf('ContributionAmount') > -1
                    ? [$rules.required]
                    : []
                "
                :class="
                  requiredColumns.indexOf('ContributionAmount') > -1
                    ? 'required'
                    : ''
                "
                label=" "
              />
            </div>
            <div
              v-bind:key="header.type.key"
              v-if="header.type.key === 'EmployerRate'"
              style="justify-content:center"
            >
              <v-btn
                v-if="index === 0"
                small
                text
                @click.prevent="rowActions[0].handler(item)"
              >
                <v-icon>
                  {{ rowActions[0].icon }}
                </v-icon>
                {{ $t(rowActions[0].title) }}
              </v-btn>
              <no-autocomplete-textfield
                clearable
                style="min-width:200px;padding:0"
                :fixedId="'employer-rate-textbox' + item.Identifier"
                v-bind:key="header.type.key"
                :value="item.EmployerRate"
                @input="updateRow($event, item, 'EmployerRate')"
                @keydown="currencyKeydown"
                @keyup="currencyKeyUp($event, item, 'EmployerRate')"
                :rules="
                  requiredColumns.indexOf('EmployerRate') > -1
                    ? [$rules.required]
                    : []
                "
                :class="
                  requiredColumns.indexOf('EmployerRate') > -1 ? 'required' : ''
                "
                label=" "
              />
            </div>
            <div
              v-bind:key="header.type.key"
              v-if="header.type.key === 'ExpectedContribution'"
              style="justify-content:center"
            >
              <v-btn
                v-if="index === 0"
                small
                text
                @click.prevent="rowActions[0].handler(item)"
              >
                <v-icon>
                  {{ rowActions[0].icon }}
                </v-icon>
                {{ $t(rowActions[0].title) }}
              </v-btn>
              <no-autocomplete-textfield
                :disabled="true"
                style="min-width:200px;padding:0"
                :fixedId="'hours-expected-contribution-textbox' + item.Id"
                :value="item.ExpectedContribution"
                @input="updateRow($event, item, 'ExpectedContribution')"
                @keydown="currencyKeydown"
                @keyup="currencyKeyUp($event, item, 'ExpectedContribution')"
                :rules="
                  requiredColumns.indexOf('ExpectedContribution') > -1
                    ? [$rules.required]
                    : []
                "
                :class="
                  requiredColumns.indexOf('ExpectedContribution') > -1
                    ? 'required'
                    : ''
                "
                label=" "
              />
            </div>
            <div
              v-bind:key="header.type.key"
              v-if="header.type.key === 'ContributionDiff'"
              style="justify-content:center"
            >
              <v-btn
                v-if="index === 0"
                small
                text
                @click.prevent="rowActions[0].handler(item)"
              >
                <v-icon>
                  {{ rowActions[0].icon }}
                </v-icon>
                {{ $t(rowActions[0].title) }}
              </v-btn>
              <no-autocomplete-textfield
                :disabled="true"
                style="min-width:200px;padding:0"
                :fixedId="'hours-contribution-diff-textbox' + item.Id"
                :value="item.ContributionDiff"
                @input="updateRow($event, item, 'ContributionDiff')"
                @keydown="currencyKeydown"
                @keyup="currencyKeyUp($event, item, 'ContributionDiff')"
                :rules="
                  requiredColumns.indexOf('ContributionDiff') > -1
                    ? [$rules.required]
                    : []
                "
                :class="
                  requiredColumns.indexOf('ContributionDiff') > -1
                    ? 'required'
                    : ''
                "
                label=" "
              />
            </div>
          </template>
        </pbas-data-table>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn text @click="$emit('close')">{{ $t("globals.cancel") }}</v-btn>
        <v-btn
          :disabled="!valid"
          color="primary"
          :loading="saving"
          @click="save"
        >
          {{ $t("globals.save") }}
        </v-btn>
      </v-card-actions>
    </material-card>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "../components/ErrorHandler";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield";
import TransSelect from "../components/TransSelect";
import TransSelect2 from "../components/TransSelect2";
import CurrencyTextfield from "../components/CurrencyTextfield";
import InMemoryPendingHoursHeaders from "../headers/InMemoryPendingHours";
import { InMemoryProvider } from "pbas-vue-components";
import AutoSelect from "../components/AutoSelect";
import TransEnum from "../components/TransEnum.vue";
import returnable from "vuetify/lib/mixins/returnable";
export default {
  components: {
    ErrorHandler,
    CurrencyTextfield,
    NoAutocompleteTextfield,
    TransSelect,
    TransSelect2,
    AutoSelect,
    TransEnum,
  },
  props: ["requiredColumns", "optionalColumns", "pendingImportId", "employers"],
  data() {
    return {
      rowActions: [
        {
          title: "globals.delete",
          name: "delete",
          icon: "delete",
          handler: (item) => {
            this.provider.items = this.provider.items.filter(
              (o) => o.Identifier !== item.Identifier
            );
            this.$refs.table.getDataAsync();
          },
        },
      ],
      floatActions: [
        {
          text: "components.memberselfpaymentsaddmany.add_row",
          color: this.$vuetify.theme.themes.light.success,
          name: "add",
          icon: "add",
          handler: async () => {
            this.provider.items.push({
              PendingImportId: this.pendingImportId,
              Identifier: Math.random().toString(),
              MemberCertificate: null,
              Employer: null,
              Store: null,
              Frequency: null,
              Amount: null,
            });
            await this.$refs.table.getDataAsync();
          },
        },
      ],
      provider: undefined,
      valid: true,
      error: null,
      saving: false,
      terms: [],
    };
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("common", ["language"]),
    ...mapGetters("plansMembers", ["options", "planOptions"]),
  },
  mounted() {
    console.log(this.requiredColumns, this.optionalColumns);
    const headers = InMemoryPendingHoursHeaders.filter(
      (o) =>
        this.requiredColumns.indexOf(
          o.title.replace("headers.pendinghourreports.", "")
        ) > -1 ||
        this.optionalColumns.indexOf(
          o.title.replace("headers.pendinghourreports.", "")
        ) > -1
    );
    this.loading = true;
    console.log(headers.map((o) => o.type.key));

    this.provider = new InMemoryProvider(
      [
        {
          PendingImportId: this.pendingImportId,
          Identifier: Math.random().toString(),
        },
      ],
      headers
    );
  },
  methods: {
    ...mapActions("plansMembers", ["addManyPendingHourReports"]),
    // coverageAllowedDates(val, item) {
    //   const n = Date.parse(val);
    //   const d = new Date(n);
    //   let n2 = Date.parse(item.CoverageEffectiveDate);
    //   const d2 = new Date(n2);
    //   return d >= d2;
    // },
    hasValue(field) {
      return field !== null && field !== undefined && field !== "";
    },
    filterFunc2(item, search) {
      console.log(item);
      return (
        (item.Name + " " + item.Year)
          .toLowerCase()
          .indexOf(search.toLowerCase()) > -1
      );
    },
    updateRow(value, row, key) {
      const index = this.provider.items.indexOf(
        this.provider.items.filter((o) => o.Identifier === row.Identifier)[0]
      );
      this.provider.items[index][key] = value;
      this.valid = this.validate();
      this.$nextTick(() => {
        let amountTextbox = document.getElementById(
          "hours-amount-textbox" + row.Identifier
        );
        amountTextbox.style = "text-align:right";
        // this.amountBlur(row);
        const num = parseFloat(row.Amount);
        if (!isNaN(num)) {
          row.Amount = num.toFixed(2); //this.formatCurrency(num).substring(1);
        } else {
          row.Amount = null;
        }
      });
    },
    updateEmployer(value, row) {
      const index = this.provider.items.indexOf(
        this.provider.items.filter((o) => o.Identifier === row.Identifier)[0]
      );
      const employer = this.employers.filter((o) => o.Id === value.Id)[0];
      // console.log(value, row, employer, this.employers)
      this.provider.items[index].Employer = employer;
      if (this.planOptions.HasStores) {
        if (value.Stores) {
          const collator = new Intl.Collator(undefined, {
            numeric: true,
            sensitivity: "base",
          });
          console.log(value.Stores);
          value.Stores = value.Stores.filter(
            (o) => o.IsAssignable !== false
          ).sort(collator.compare);
        }
        if (
          !value.Stores ||
          value.Stores.filter((o) =>
            row.Store ? o.Id === row.Store.Id : false
          ).length === 0
        ) {
          row.Store = null;
          row.StoreId = null;
        }
      }
      this.terms = this.createEmployerTerms(value);
      this.valid = this.validate();
    },
    updateStore(value, row) {
      const index = this.provider.items.indexOf(
        this.provider.items.filter((o) => o.Identifier === row.Identifier)[0]
      );
      if (value === null) {
        this.provider.items[index].Store = null;
        return;
      }
      const store = this.provider.items[index].Employer.Stores.filter(
        (o) => o.Id === value.Id
      )[0];
      // console.log(store, this.provider.items[index].Employer.Stores, value)
      this.provider.items[index].Store = store;
      this.valid = this.validate();
    },
    validate() {
      let valid = true;
      for (let item of this.provider.items) {
        valid = this.isValid(item);
        if (!valid) {
          return false;
        }
      }
      return valid;
    },
    isValid(item) {
      let valid = true;
      for (const col of this.requiredColumns) {
        if (col === "Store") {
          valid =
            (item.Employer.Stores.length > 0 &&
              item[col] !== null &&
              item[col] !== undefined &&
              item[col] !== "") ||
            item.Employer.Stores.length === 0;
        } else if (col === "TermYear") {
          valid = item.TermName !== null && item.TermName !== undefined;
        } else {
          valid =
            item[col] !== null && item[col] !== undefined && item[col] !== "";
        }
        if (!valid) {
          return false;
        }
      }
      return valid;
    },
    itemSlotFunc(header) {
      return "item." + header.type.key;
    },
    async save() {
      this.error = null;
      this.saving = true;
      try {
        let items = JSON.parse(JSON.stringify(this.provider.items));
        for (let item of items) {
          let num = parseFloat(item.Amount);
          if (!isNaN(num)) {
            item.Amount = num;
          } else {
            delete item.Amount;
          }
          num = parseFloat(item.ContributionAmount);
          if (!isNaN(num)) {
            item.ContributionAmount = num;
          } else {
            delete item.ContributionAmount;
          }
          num = parseFloat(item.ExpectedContribution);
          if (!isNaN(num)) {
            item.ExpectedContribution = num;
          } else {
            delete item.ExpectedContribution;
          }
          num = parseFloat(item.ContributionDiff);
          if (!isNaN(num)) {
            item.ContributionDiff = num;
          } else {
            delete item.ContributionDiff;
          }
          delete item.Identifier;
          if (item.Employer !== null && item.Employer !== undefined) {
            item.EmployerId = item.Employer.Id;
            item.Employer = item.Employer.Translations.filter(
              (o) => o.LanguageCode === this.language.language
            )[0].Name;
          }
          if (item.Store !== null && item.Store !== undefined) {
            item.StoreId = item.Store.Id;
            item.Store = item.Store.Translations.filter(
              (o) => o.LanguageCode === this.language.language
            )[0].Name;
          }
          if (item.Frequency !== null && item.Frequency !== undefined) {
            item.FrequencyId = item.Frequency.Id;
            item.Frequency = item.Frequency.Translations.filter(
              (o) => o.LanguageCode === this.language.language
            )[0].DisplayValue;
          }
          if (
            item.EmploymentType !== null &&
            item.EmploymentType !== undefined
          ) {
            item.EmploymentTypeId = item.EmploymentType.Id;
            item.EmploymentType = item.EmploymentType.Translations.filter(
              (o) => o.LanguageCode === this.language.language
            )[0].DisplayValue;
          }
          if (item.Gender !== null && item.Gender !== undefined) {
            item.GenderId = item.Gender.Id;
            item.Gender = item.Gender.Translations.filter(
              (o) => o.LanguageCode === this.language.language
            )[0].DisplayValue;
          }
          if (item.TermName !== null && item.TermName !== undefined) {
            const termName = item.TermName;
            item.TermName = termName.Name;
            item.TermYear = termName.Year;
            item.TermId = termName.Id;
          }
        }

        await this.addManyPendingHourReports({
          planIdentityId: this.selectedPlan.Id,
          pendingImportId: this.pendingImportId,
          payload: items,
        });
        this.$emit("save");
      } catch (e) {
        console.error(e);
        this.error = e;
      }
      this.saving = false;
    },
    isNumeric(evt) {
      var iKeyCode = evt.which ? evt.which : evt.keyCode;
      if (
        iKeyCode != 46 &&
        iKeyCode > 31 &&
        (iKeyCode < 48 || iKeyCode > 57) &&
        (iKeyCode < 96 || iKeyCode > 105)
      )
        return false;

      return true;
    },
    currencyKeyUp(evt, row, key) {
      var el = evt.srcElement;
      var value = el.value;
      if (!value) return;
      var start = el.selectionStart;
      var end = el.selectionEnd;
      el.value = parseFloat(value).toFixed(2);
      if (start === 0 && end === 0) {
        end = 1;
      }
      el.setSelectionRange(start, end);
      const num = parseFloat(value);
      if (!isNaN(num)) {
        value = num.toFixed(2); //this.formatCurrency(num).substring(1);
      } else {
        value = null;
      }
      this.updateRow(value, row, key);
    },
    currencyKeydown(evt, sender) {
      if (evt.keyCode == 8 || evt.keyCode == 46) {
        return;
      }
      var el = evt.srcElement;
      var value = el.value;
      if (!value) {
        if (evt.keyCode == 190 || evt.keyCode == 110) {
          el.value = value + "0.";
          el.setSelectionRange(2, 2);
        } else if (this.isNumeric(evt)) {
          el.value = value + ".00";
          el.setSelectionRange(0, 0);
        }
      } else if (parseFloat(value) && value.indexOf(".") == -1) {
        var start = el.selectionStart;
        el.value = value + ".00";
        el.setSelectionRange(start, start);
      }
      value = el.value;
      if (
        (evt.keyCode == 190 || evt.keyCode == 110) &&
        value.indexOf(".") >= 0
      ) {
        el.setSelectionRange(value.indexOf(".") + 1, value.indexOf(".") + 1);
        evt.preventDefault();
        return;
      }

      if (!this.isNumeric(evt) && (evt.keyCode < 35 || evt.keyCode > 40)) {
        evt.preventDefault();
      } else if (evt.keyCode === 13) {
        evt.preventDefault();
      }
    },
    currencyKeyUpNegative(evt, row, key) {
      if (evt.keyCode === 189) {
        return;
      }
      var el = evt.srcElement;
      var value = el.value;
      console.log(value);
      if (!value) return;
      if (
        value === "-0" ||
        value === "-0." ||
        value === "-0.0" ||
        value === "-0.00"
      ) {
        return;
      }
      console.log("2222222222222", value);
      let decimal = parseFloat(value);
      if (isNaN(decimal)) {
        return;
      }
      var start = el.selectionStart;
      var end = el.selectionEnd;
      el.value = decimal.toFixed(2);
      if (start === 0 && end === 0) {
        end = 1;
      }
      el.setSelectionRange(start, end);
      const num = parseFloat(value);
      if (!isNaN(num)) {
        value = num.toFixed(2); //this.formatCurrency(num).substring(1);
      } else {
        value = null;
      }
      this.updateRow(value, row, key);
    },
    currencyKeydownNegative(evt, sender) {
      console.log(evt);
      if (evt.keyCode == 8 || evt.keyCode == 46) {
        return;
      }
      if (evt.keyCode === 189) {
        return;
      }
      var el = evt.srcElement;
      var value = el.value;

      if (!value) {
        if (evt.keyCode == 190 || evt.keyCode == 110) {
          el.value = value + "0.";
          el.setSelectionRange(2, 2);
        } else if (this.isNumeric(evt)) {
          el.value = value + ".00";
          el.setSelectionRange(0, 0);
        }
      } else if (
        value !== "-" &&
        parseFloat(value) &&
        value.indexOf(".") == -1
      ) {
        console.log(value);
        var start = el.selectionStart;
        el.value = value + ".00";
        el.setSelectionRange(start, start);
      }
      console.log(value, el.value);
      value = el.value;
      console.log(value);
      if (evt.keyCode == 190 || evt.keyCode == 110) {
        if (value.indexOf(".") >= 0) {
          el.setSelectionRange(value.indexOf(".") + 1, value.indexOf(".") + 1);
          evt.preventDefault();
        }
        return;
      }

      if (!this.isNumeric(evt) && (evt.keyCode < 35 || evt.keyCode > 40)) {
        evt.preventDefault();
      } else if (evt.keyCode === 13) {
        evt.preventDefault();
      }
    },
    async setData(items) {
      this.$nextTick(() => {
        for (let item of items) {
          let amountTextbox = document.getElementById(
            "hours-amount-textbox" + item.Identifier
          );
          amountTextbox.style = "text-align:right";
          // this.amountBlur(item);
          const num = parseFloat(item.Amount);
          if (!isNaN(num)) {
            item.Amount = num.toFixed(2); //this.formatCurrency(num).substring(1);
          } else {
            item.Amount = null;
          }
        }
      });
    },
    createEmployerTerms(employer) {
      console.log(employer);
      if (employer === null || employer === undefined) {
        return [];
      }
      if (employer.Terms === null || employer.Terms === undefined) {
        return [];
      }
      return this.sortDateDesc(employer.Terms);
    },
    sortDateDesc(terms) {
      console.log(terms);
      return terms.sort((a, b) => {
        console.log(a, b);
        if (a.Year > b.Year) {
          return -1;
        } else if (a.Year === b.Year) {
          const aName = parseInt(a.Name);
          const bName = parseInt(b.Name);
          if (isNaN(aName) || isNaN(bName)) {
            return this.compareDesc(a.Name, b.Name);
          } else {
            return this.compareDesc(aName, bName);
          }
        } else {
          return 1;
        }
      });
    },
    compareDesc(a, b) {
      if (a > b) {
        return -1;
      } else if (a === b) {
        return 0;
      } else {
        return 1;
      }
    },
  },
};
</script>
<style scoped>
.v-application .white {
  background-color: rgba(0, 0, 0, 0.87) !important;
}
</style>
